const DICT = {} satisfies Record<string, [string, string, string]>;

/**
 * @see https://gist.github.com/termi/7081408#file-declension-js-L18
 */
export const decline_dict_word = (word: keyof typeof DICT, number: number) => {
  number = number % 100;

  // prettier-ignore
  return number <= 14 && number >= 11
      ? DICT[word][2]
      : (number %= 10) < 5
        ? number >= 2
          ? DICT[word][1]
          : number === 1
            ? DICT[word][0]
            : number === 0
              ? DICT[word][2]
              : DICT[word][0]
        : DICT[word][2];
};

/**
 * @see https://gist.github.com/termi/7081408#file-declension-js-L18
 */
export const decline_dynamic_word = (word: [string, string, string], number: number) => {
  number = number % 100;

  // prettier-ignore
  return number <= 14 && number >= 11
      ? word[2]
      : (number %= 10) < 5
        ? number >= 2
          ? word[1]
          : number === 1
            ? word[0]
            : number === 0
              ? word[2]
              : word[0]
        : word[2];
};
